export default __webpack_public_path__ + "static/media/pulse.f5874da3.svg";